import { handleOpenChat } from '@/helpers';
import { LINK } from '@/constants';
import { ChatIcon, EmailIcon, GuideIcon } from '@/icons';
import { HelpCenterCardProps } from './components/HelpCenterCard';

export const helpCenterData: HelpCenterCardProps[] = [
  {
    icon: <ChatIcon />,
    title: '24/7 Live chat',
    description: 'Reply immediately',
    onClick: handleOpenChat,
  },
  {
    icon: <EmailIcon />,
    title: 'Contact email',
    description: `Typically reply in 24h`,
    url: 'mailto:support@omegatheme.com',
  },
  {
    icon: <GuideIcon />,
    title: 'User guide docs',
    description: 'Find solutions on your own',
    url: LINK.HELP_CENTER,
  },
];
